import { mapActions, mapGetters } from 'vuex'
import 'custom-event-polyfill'

/**
 * @param paramNamePPlusToken - name of the query parameter for pplus token
 * @param paramNameMsisdn - name of the query parameter for msisdn
 * @returns vue mixin for pplus token handling
 */
export default function (paramNamePPlusToken = 'id', paramNameMsisdn = 'msisdn') {
  return {
    async mounted () {
      const urlParameters = new URLSearchParams(window.location.search)
      const pPlusToken = urlParameters.get(paramNamePPlusToken)
      const msisdn = urlParameters.get(paramNameMsisdn)

      if (pPlusToken && msisdn) {
        const validated = await this.validatePPlusToken({ msisdn, pPlusToken })

        if (validated) {
          // generic case: somewhere in the page there might be someone interested in our token
          // e.g. because it's required to hide some texts
          // custom events require polyfill in IE11
          document.dispatchEvent(new CustomEvent('validatedPPlusToken', { detail: pPlusToken }))
        }
      }
    },
    methods: {
      ...mapActions('activation/info', [
        'validatePPlusToken'
      ])
    },
    computed: {
      ...mapGetters('activation/info', [
        'hasValidatedPPlusToken'
      ])
    }
  }
}
